"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _game = require("../actions/game");

var actions = _interopRequireWildcard(_game);

var _GameActionTypes = require("../constants/action-types/GameActionTypes");

var types = _interopRequireWildcard(_GameActionTypes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

exports.default = function (store) {
  return function (next) {
    return function (action) {
      //TODO: We can call store.dispatch(action) from here and the action will travel the whole middleware chain again (including the current middleware). Is this useful for us...?

      /*
       //TODO:
       //if we ever define a remoteRequest that isn't async then it won't go through
       // that thunk flow. Therefore, it won't go thru all the middleware again (such as saving to DB). The other TODO above could be beneficial in that case..
       */

      /**
       * Handle remoteRequest
       * Sends an action to the server, which will then dispatch a different,
       * requested action in return
       * For example:
       *  remoteRequest for RunCode will trigger a runCode async action on the server
       */
      if (action.meta && action.meta.remoteRequest === true) {
        if (action.meta.senderPlayerId >= 0) {
          //TODO: Can replace with remoteActionMap..?
          switch (action.type) {
            case types.REMOTE_REQUEST_RUN_CODE:
              return next(actions.runCode(action.meta.senderPlayerId));

            case types.REMOTE_REQUEST_SUBMIT_CODE:
              return next(actions.submitCode(action.meta.senderPlayerId));

            case types.REMOTE_REQUEST_SKIP_TASK:
              return next(actions.skipTask());

            case types.REMOTE_REQUEST_NEXT_TASK:
              return next(actions.nextTask(action.meta.senderPlayerId));
          }
        }

        return;
      }

      return next(action);
    };
  };
};